import * as constants from 'constants/actions'

import {
  errorProgressState,
  requestProgressState,
  successProgressState,
} from 'utils/progress'

import initialState from './initialState'

function progressReducer(state = initialState.progress, action) {
  switch (action.type) {
    case constants.API_LOGIN_REQUEST:
      return {
        ...state,
        login: {
          ...requestProgressState,
        },
      }
    case constants.API_LOGIN_SUCCESS:
      return {
        ...state,
        login: {
          ...successProgressState,
        },
      }
    case constants.API_LOGIN_ERROR:
      return {
        ...state,
        login: {
          ...errorProgressState,
          error: action.error
        },
      }

    case constants.API_RESET_REQUEST_REQUEST:
      return {
        ...state,
        resetRequest: {
          ...requestProgressState,
        },
      }

    case constants.API_RESET_REQUEST_SUCCESS:
      return {
        ...state,
        resetRequest: {
          ...successProgressState,
        },
      }
    case constants.API_RESET_REQUEST_ERROR:
      return {
        ...state,
        resetRequest: {
          ...errorProgressState,
          error: action.error
        },
      }

    case constants.API_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        reset: {
          ...requestProgressState,
        },
      }

    case constants.API_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        reset: {
          ...successProgressState,
        },
      }
    case constants.API_RESET_PASSWORD_ERROR:
      return {
        ...state,
        reset: {
          ...errorProgressState,
          error: action.error
        },
      }
    case constants.API_VERIFY_EMAIL_REQUEST:
      return {
        ...state,
        verifyRequest: {
          ...requestProgressState,
        }
      }
    case constants.API_VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        verifyRequest: {
          ...successProgressState,
        }
      }
    case constants.API_VERIFY_EMAIL_ERROR:
      return {
        ...state,
        verifyRequest: {
          ...errorProgressState,
          error: action.error
        }
      }
    case constants.API_CREATE_ORGANISATION_REQUEST:
      return {
        ...state,
        createOrganisation: {
          ...requestProgressState
        }
      }
    case constants.API_CREATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        createOrganisation: {
          ...successProgressState
        }
      }
    case constants.API_CREATE_ORGANISATION_ERROR:
      return {
        ...state,
        createOrganisation: {
          ...errorProgressState,
          error: action.error
        }
      }
    case constants.API_UPDATE_ORGANISATION_REQUEST:
      return {
        ...state,
        updateOrganisation: {
          ...requestProgressState
        }
      }
    case constants.API_UPDATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        updateOrganisation: {
          ...successProgressState
        }
      }
    case constants.API_UPDATE_ORGANISATION_ERROR:
      return {
        ...state,
        updateOrganisation: {
          ...errorProgressState,
          error: action.error
        }
      }
    case constants.API_GET_ORGANISATION_CODE_REQUEST:
      return {
        ...state,
        getOrganisationCode: {
          ...requestProgressState
        }
      }
    case constants.API_GET_ORGANISATION_CODE_SUCCESS:
      return {
        ...state,
        getOrganisationCode: {
          ...successProgressState
        }
      }
    case constants.API_GET_ORGANISATION_CODE_ERROR:
      return {
        ...state,
        getOrganisationCode: {
          ...errorProgressState,
          error: action.error
        }
      }
    case constants.API_CREATE_GROUP_REQUEST:
      return {
        ...state,
        createGroup: {
          ...requestProgressState
        }
      }
    case constants.API_CREATE_GROUP_SUCCESS:
      return {
        ...state,
        createGroup: {
          ...successProgressState
        }
      }
    case constants.API_CREATE_GROUP_ERROR:
      return {
        ...state,
        createGroup: {
          ...errorProgressState
        }
      }
    case constants.API_CREATE_USER_REQUEST:
      return {
        ...state,
        createAccount: {
          ...requestProgressState
        }
      }
    case constants.API_CREATE_USER_SUCCESS:
      return {
        ...state,
        createAccount: {
          ...successProgressState
        }
      }
    case constants.API_CREATE_USER_ERROR:
      return {
        ...state,
        createAccount: {
          ...errorProgressState
        }
      }
    case constants.API_CHECK_TOKEN_REQUEST:
      return {
        ...state,
        checkToken: {
          ...requestProgressState
        }
      }
    case constants.API_CHECK_TOKEN_SUCCESS:
      return {
        ...state,
        checkToken: {
          ...successProgressState
        }
      }
    case constants.API_CHECK_TOKEN_ERROR:
      return {
        ...state,
        checkToken: {
          ...errorProgressState,
          error: action.error
        }
      }
    case constants.API_EDIT_PASSWORD_REQUEST:
      return {
        ...state,
        changePassword: {
          ...requestProgressState,
        }
      }
    case constants.API_EDIT_PASSWORD_SUCCESS:
      return {
        ...state,
        changePassword: {
          ...successProgressState,
        }
      }
    case constants.API_EDIT_PASSWORD_ERROR:
      return {
        ...state,
        changePassword: {
          ...errorProgressState,
          error: action.error
        }
      }
    case constants.API_UPDATE_TRAP_REQUEST:
      return {
        ...state,
        updateTrap: {
          ...requestProgressState,
        }
      }
    case constants.API_UPDATE_TRAP_SUCCESS:
      return {
        ...state,
        updateTrap: {
          ...successProgressState,
        }
      }
    case constants.API_UPDATE_TRAP_ERROR:
      return {
        ...state,
        updateTrap: {
          ...errorProgressState,
          error: action.error
        }
      }
    default:
      return state
  }
}

export default progressReducer



// WEBPACK FOOTER //
// ./src/reducers/progressReducer.js